export function transformObjectFieldsToStringArray(obj: any): string[] {
  return Object.keys(obj).map((key: string) => {
    return obj[key];
  });
}
